import React, { Component } from "react";
import { Text } from "react-internationalization";
import moment from "moment";
import {
  saveAgentDetails,
  saveAgentproductIds,
  setStateParams,
} from "../../Redux/Actions/webAppActions";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import * as DateUtil from "../../Utils/DatePicker";
import { handleDateChange } from "../../Utils/DateFormatter";
import { handleDateChangeNew } from "../../Utils/DateFormatter1";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import { FieldLabel } from "../translations/dynamic";
import {
  DataValidation,
  NEBRASKA_CONSTS,
  VERDA_CONSTS,
  ILS_CONSTS,
  fetch_NeBraska_Product_Types,
  contactInfoSoa,
} from "../../Utils/StaticData/Constant";
class Soa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productSelected: 0,
      snackBarOpen: false,
      alertMsg: "",
      severity: "success",
      vertical: "top",
      horizontal: "center",
      IMC: [
        { label: "Sales event", value: "Sales" },
        { label: "Walk-in", value: "Walk" },
        { label: "Inbound call", value: "Inboun" },
        { label: "Outbound Call", value: "Outbou" },
        { label: "Permission to call card", value: "Permis" },
        { label: "Other", value: "Other" },
      ],
      // IMC: [
      //   "Sales event",
      //   "Walk-in",
      //   "Inbound call",
      //   "Outbound Call",
      //   "Permission to call card",
      //   "Other",
      // ],
      productIds: {},
      Soa: {
        repName: "",
        repRelationShip: "",
        repSignature: "",
        repDate: "",
        // MA1: "NO",
        // DSNP: "NO",
        // E005: "NO",
        // E006: "NO",
        // PDP1: "NO",
        productIds: "",
        agentName: "",
        beneficiaryName: "",
        agentPhone: "",
        beneficiaryPhone: "",
        agentSignutre: "",
        initialMethodOfContact: "",
        salesChannelOth: "",
        beneficiaryAddress: "",
        dateApntmntCmpltd: "",
        isAuthRep: "NO",
        agentSignDate: "",
        beneBirthDate: "",
      },
      // }:{
      //   name: this.props.SOAData?.repName?this.props.SOAData?.repName:"",
      //   relationship: this.props.SOAData?.relationshipToBene?this.props.SOAData?.relationshipToBene:"",
      //   signature: this.props.SOAData?.beneRepSignature?this.props.SOAData?.beneRepSignature:"",
      //   date: this.props.SOAData?.beneRepSignDate?this.props.SOAData?.beneRepSignDate:"",
      //   MA: "NO",
      //   MAPD: "NO",
      //   PDP: "NO",
      //   MEDSUP: "NO",
      //   agentName: this.props.SOAData?.agentName?this.props.SOAData?.agentName:"",
      //   benName: this.props.SOAData?.beneName?this.props.SOAData?.beneName:"",
      //   agentPh:this.props.SOAData?.agentPhone?this.props.SOAData?.agentPhone:"",
      //   benPh: this.props.SOAData?.benePhone?this.props.SOAData?.benePhone:"",
      //   agentSign: this.props.SOAData?.agentSign?this.props.SOAData?.agentSign:"",
      //   contact: this.props.SOAData?.initialMethodOfContact?this.props.SOAData?.initialMethodOfContact:"",
      //   benAdd: this.props.SOAData?.beneAddress?this.props.SOAData?.beneAddress:"",
      //   dac: this.props.SOAData?.appointmentDateComp?this.props.SOAData?.appointmentDateComp:"",
      // },
    };
  }
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  async componentDidMount() {
    /* 
    @@@
    Below setState is picking up soa data from store, 
     as some fields are specific to a particular customer and as per already written logic, 
     if we metion those fields in the below setState with out any condition 
     then save&next validation won't work
     @@@
     */
    await this.setState({
      ...this.state,
      Soa: {
        ...this.state.Soa,
        repName: this.props.soa?.repName ? this.props.soa?.repName : "",
        repRelationShip: this.props.soa?.repRelationShip
          ? this.props.soa?.repRelationShip
          : "",
        repSignature: this.props.soa?.repSignature
          ? this.props.soa?.repSignature
          : "",
        repDate: this.props.soa?.repDate ? this.props.soa?.repDate : "",
        productIds: this.props.soa?.productIds
          ? this.props.soa?.productIds
          : "",
        agentName: this.props.soa?.agentName ? this.props.soa?.agentName : "",
        beneficiaryName: this.props.soa?.beneficiaryName
          ? this.props.soa?.beneficiaryName
          : "",
        agentPhone: this.props.soa?.agentPhone
          ? this.props.soa?.agentPhone?.length === 10
            ? "(" +
              this.props.soa?.agentPhone?.slice(0, 3) +
              ") " +
              this.props.soa?.agentPhone?.slice(3, 6) +
              "-" +
              this.props.soa?.agentPhone?.slice(6, 10)
            : this.props.soa?.agentPhone
          : "",
        beneficiaryPhone: this.props.soa?.beneficiaryPhone
          ? this.props.soa?.beneficiaryPhone?.length === 10
            ? "(" +
              this.props.soa?.beneficiaryPhone?.slice(0, 3) +
              ") " +
              this.props.soa?.beneficiaryPhone?.slice(3, 6) +
              "-" +
              this.props.soa?.beneficiaryPhone?.slice(6, 10)
            : this.props.soa?.beneficiaryPhone
          : "",
        agentSignutre: this.props.soa?.agentSignutre
          ? this.props.soa?.agentSignutre
          : "",
        initialMethodOfContact: this.props.soa?.initialMethodOfContact
          ? this.props.soa?.initialMethodOfContact
          : "",
        beneficiaryAddress: this.props.soa?.beneficiaryAddress
          ? this.props.soa?.beneficiaryAddress
          : "",
        dateApntmntCmpltd: this.props.soa?.dateApntmntCmpltd
          ? this.props.soa?.dateApntmntCmpltd
          : "",
        salesChannelOth: this.props.soa?.salesChannelOth
          ? this.props.soa?.salesChannelOth
          : "",
        isAuthRep: this.props.soa?.isAuthRep ? this.props.soa?.isAuthRep : "NO",
        medicaidId: this.props.soa?.medicaidId ??"",
        beneficiaryInitial: this.props.soa?.beneficiaryInitial??"",
      },
      productSelected: this.props?.soa?.productIds?.length > 0 ? 1 : 0,
    });

    if (this.props.customerId === NEBRASKA_CONSTS.ID) {
      /*
      This if block is only written for NeBraska customer to fetch soa data from store,
      this written separately to persist the already written logic.
      */
      this.setState({
        ...this.state,
        Soa: {
          ...this.state.Soa,
          agentSignDate: this.props.soa?.agentSignDate
            ? this.props.soa?.agentSignDate
            : this.props.SOAData?.agentSignDate,
          beneBirthDate: this.props.soa?.beneBirthDate
            ? this.props.soa?.beneBirthDate
            : this.props.SOAData?.beneBirthDate,
        },
      });
    }

    // }
    if (
      this.state?.Soa?.repRelationShip?.length > 0 &&
      this.state?.Soa?.repName?.length > 0
    ) {
      await this.setState({
        Soa: {
          ...this.state.Soa,
          isAuthRep: "YES",
        },
      });
    }
    if (
      this.props.pendingApplFlag === false &&
      this.props.isSoaFilled === false
    ) {
      let agentPhone =
        this.props?.agentPhone && this.props?.agentPhone?.replace(/\s/g, "");
      agentPhone = agentPhone
        ? agentPhone?.length === 10
          ? "(" +
            agentPhone?.slice(0, 3) +
            ") " +
            agentPhone?.slice(3, 6) +
            "-" +
            agentPhone?.slice(6, 10)
          : agentPhone
        : "";
      this.setState({
        ...this.state,
        Soa: {
          ...this.state.Soa,
          agentName:
            this.props.agentId?.trim() +
            "-" +
            this.props?.agentFullName?.trim(),
          agentPhone,
        },
      });
      this.props.saveAgentDetails(
        "agentName",
        this.props?.agentId?.trim() + "-" + this.props?.agentFullName?.trim()
      );
      this.props.saveAgentDetails("agentPhone", agentPhone);
    }
    if(this.props.lang==="es"){
      this.setState({
        ...this.state,
        IMC: [
          { label: "Evento de ventas", value: "Sales" },
          { label: "Sin cita previa", value: "Walk" },
          { label: "llamada entrante", value: "Inboun" },
          { label: "Llamada saliente", value: "Outbou" },
          { label: "Permiso para llamar a la tarjeta.", value: "Permis" },
          { label: "Otro", value: "Other" },
        ]
      })
    }
  }
  dateValidator = () => {
    let dateValidationFlag = false;
    let commonDate =
      moment(this.state.Soa.repDate, "MM/DD/YYYY", true).isValid() &&
      moment(this.state.Soa.dateApntmntCmpltd, "MM/DD/YYYY", true).isValid();
    switch (this.props.customerId) {
      case NEBRASKA_CONSTS.ID: {
        dateValidationFlag =
          commonDate &&
          moment(this.state.Soa?.agentSignDate, "MM/DD/YYYY", true).isValid();
        break;
      }
      default: {
        dateValidationFlag = commonDate;
        break;
      }
    }
    return dateValidationFlag;
  };
  saveAndNext = async (event) => {
    event.persist();

    //await this.props.setStateParams("productIds", this.state.productIds);
    let Soa1 = this.state.Soa;
    let allFieldsEntered = true;
    let otherflag = true;
    let flag =
      Soa1.isAuthRep === "YES"
        ? Soa1.repName === "" || Soa1.repRelationShip === ""
          ? false
          : true
        : true;

    Object.keys(Soa1).map((key) => {
      if (
        key != "salesChannelOth" &&
        key != "repName" &&
        key != "repRelationShip" &&
        key != "agentSignDate" &&
        key != "beneBirthDate" && //agentSignDate and beneBirthDate this is written specifically for NeBraska customer in order to persist the current written logic
        key != "medicaidId" && //medicaid id is written for ILS
        (this.props.customerId===ILS_CONSTS.ID?true:key != "beneficiaryInitial") &&  //beneficiaryInitial id is written for ILS
        Soa1[key] === ""
      ) {
        allFieldsEntered = false;
      }
      return allFieldsEntered;
    });
    if (
      this.state.Soa.salesChannelOth === "" &&
      this.state.Soa.initialMethodOfContact === "Other"
    ) {
      otherflag = false;
    }
    // SONAR let productIdEntered = false;

    // for (const key in this.state?.productIds) {
    //   if (this.state.productIds[key] == "YES") {
    //     productIdEntered = true;
    //   }
    // }

    if (allFieldsEntered === true && otherflag === true && flag === true) {
      if (this.dateValidator()) {
        // it is great function used to valiadte customer specific dates and returns true/false
        if (
          (Soa1.agentPhone.length === 14 || Soa1.agentPhone.length===12) &&
          Soa1.beneficiaryPhone.length === 14
        ) {
          this.props.redirect(event, Soa1, "next0");
        } else {
          this.setState((prevState) => ({
            ...prevState,
            snackBarOpen: true,
            alertMsg: "Please enter all 10-digit phone number *.",
            severity: "error",
          }));
        }
      } else {
        this.setState((prevState) => ({
          ...prevState,
          snackBarOpen: true,
          alertMsg: this.props.lang==="en"?"please enter a valid date.":"por favor ingrese una fecha válida.",
          severity: "error",
        }));
      }
    } else {
      this.setState((prevState) => ({
        ...prevState,
        snackBarOpen: true,
        alertMsg: this.props.lang==="en"?"Please enter all mandatory fields":"Por favor ingrese todos los campos obligatorios",
        severity: "error",
      }));
    }
  };
  handleDates = (fieldId) => {
    // var self = this;
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
      DateUtil.getDatePicker("#" + fieldId);
      //.datepicker("refresh");
    });
  };
  setDates = async (fieldId, value) => {
    if (fieldId === "beneBirthDate") {
      if (new Date(value) > new Date()) {
        this.setState({
          ...this.state,
          snackBarOpen: true,
          alertMsg: "Birth date can not be a future date.",
          severity: "error",
          data: { ...this.state.data, [fieldId]: "" },
        });
        return;
      }
    }
    await this.setState({ Soa: { ...this.state.Soa, [fieldId]: value } });
    await this.props.saveAgentDetails(fieldId, value);
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    //value = handleDateChange(value);
    DateUtil.getDatePicker("#" + name).datepicker("hide");
    value = handleDateChangeNew(value);
    if (value.length === 10) {
      if (!moment(value, "MM/DD/YYYY", true).isValid()) {
        this.setState({
          snackBarOpen: true,
          alertMsg: "Please enter a valid date ",
          severity: "error",
        });
      }
    }
    // if (value === "") {
    //   this.setState({
    //     snackBarOpen: true,
    //     alertMsg: "Please enter date in the MM/DD/YYYY format",
    //     severity: "error",
    //   });
    // }
    await this.setState({
      Soa: { ...this.state.Soa, [name]: value },
    });
    // DateUtil.getDatePicker("#"+name).datepicker("show")
    this.props.saveAgentDetails(name, value);
  };
  formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  handleChange = async (event) => {
    let name = event.target ? event.target.name : event.name;
    let value = "";
    if (
      name.toLowerCase().includes("planselect") ||
      name.toLowerCase().includes("initialmethodofcontact")
    ) {
      value = event.target ? event.target.value : event.value;
    } else {
      if (
        name.toLowerCase().includes("agentname") ||
        name.toLowerCase().includes("beneficiaryname") ||
        name.toLowerCase().includes("repname")
      ) {
        value = event.target.value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase();
      } else {
        value = event.target
          ? event.target.value.toUpperCase()
          : event.value.toUpperCase();
      }
    }
    if (
      // name.toLowerCase().includes("agentphone") ||
      name.toLowerCase().includes("beneficiaryphone")
    ) {
      value = this.formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
      if(name.toLowerCase().includes("agentphone")){
        // if(this.props.customerId===ILS_CONSTS.ID){
        //   value = value.replace(/[^0-9,-]/g, "");
        // }else{
          value = this.formatPhoneNumber(value.replace(/[^0-9,]/g, ""));
       // }
      }

    await this.setState({ Soa: { ...this.state.Soa, [name]: value } });
    this.props.saveAgentDetails(name, value);
    if (this.state?.Soa?.repRelationShip === "SLF") {
      await this.setState({
        Soa: { ...this.state.Soa, beneficiaryName: this.state.Soa.repName },
      });
      this.props.saveAgentDetails("beneficiaryName", this.state.Soa.repName);
    }
    if (this.state?.Soa?.initialMethodOfContact != "Other") {
      await this.setState({ Soa: { ...this.state.Soa, salesChannelOth: "" } });
      this.props.saveAgentDetails("salesChannelOth", "");
    }
  };
  handleMutipleCheckbox = async (event) => {
    let name = event.target.name;
    let value = event.target.value;

    //  let multi=[]
    //let multiple=[]
    let multiple = this.state?.Soa?.productIds;
    // ? this.state?.data?.productName
    // : [];
    if (multiple?.includes(value)) {
      //let index = multiple.indexOf(value);
      //multiple.splice(index, 1);
      multiple = multiple.replace(value, "")?.replace(",,", ",");
      //removing start and end commas 2 if conditions
      if (multiple[0] === ",") {
        multiple = multiple.substring(1, multiple.length);
      }
      if (multiple[multiple.length - 1] === ",") {
        multiple = multiple.substring(0, multiple.length - 1);
      }
    } else {
      if (multiple?.length > 0) {
        multiple = multiple + "," + value;
      } else {
        multiple = value;
      }
    }
    await this.setState({ Soa: { ...this.state.Soa, [name]: multiple } });
    this.props.saveAgentDetails(name, multiple);
    if (multiple.length > 0) {
      this.setState({
        productSelected: 1,
      });
    } else {
      this.setState({
        productSelected: 0,
      });
    }
    // if (value == "YES") {
    //   this.setState({
    //     productSelected: this.state.productSelected + 1,
    //   });
    // } else {
    //   this.setState({
    //     productSelected: this.state.productSelected - 1,
    //   });
    // }
  };
  handleCheckbox = async (event) => {
    let name = event.target ? event.target.name : event.name;
    let value = event.target
      ? event.target.checked
        ? "YES"
        : "NO"
      : event.checked
      ? "YES"
      : "NO";
    this.setState({
      Soa: {
        ...this.state.Soa,
        [name]: value,
      },
      productIds: {
        ...this.state.productIds,
        [name]: value,
      },
    });

    // if (value == "YES") {
    //   this.setState({
    //     productSelected: this.state.productSelected + 1,
    //   });
    // } else {
    //   this.setState({
    //     productSelected: this.state.productSelected - 1,
    //   });
    // }

    await this.props.saveAgentproductIds(name, value);
    this.props.saveAgentDetails(name, value);
  };
  render() {
    const { snackBarOpen, severity, alertMsg, vertical, horizontal } =
      this.state;
    let customCardArray=this.props.customerId!==NEBRASKA_CONSTS.ID
                  ?this?.props.planCardData
                  :fetch_NeBraska_Product_Types(this?.props.planCardData)
    let contacts=contactInfoSoa(this.props.customerId)
    return (
      <React.Fragment>
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={6000}
          onClose={this.handleClose}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert onClose={this.handleClose} severity={severity}>
            {alertMsg}
          </Alert>
        </Snackbar>
        <div
          class={
            this.props.isSoaFilled === true
              ? "tab-content tab-contentSharp disable-form"
              : "tab-content tab-contentSharp"
          }
        >
          <div id="step0" class="container-Cambia tab-pane active">
            <h3 class="tab-heading mb-3">
              <strong><Text id="app.scope"/></strong>
            </h3>
            <p>
              <Text id="soa.header1" />
            </p>

            {[NEBRASKA_CONSTS.ID].every((c) => c !== this.props.customerId) && (
              <div class="border border-secondary mb-4">
                <p class="ml-2">
                  <strong>
                    <Text id="app.scopeAppointment"/>
                  </strong>
                </p>
                <div class="row ml-2">
                  <div class="col-md-4">
                    <p>
                      <strong><Text id="app.callus"/></strong>
                      {
                         <a class="call-us-color" href={`tel:+${contacts.tel}`}>
                         {contacts.phNum}
                       </a>
                      }
                    </p>
                  </div>
                  <div class="col-md-8">
                    <p>
                      <strong><Text id="app.faxus"/></strong>
                      <Text id="app.faxusUsing"/>
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div class="mt-3 mb-3">
              <p>
                <strong>
                  <Text id="soa.para1" />
                  <Text id="soa.para2" />
                </strong>
                <Text id="soa.para3" />
                <Text id="soa.para4" />
                <Text id="soa.para5" />
                <Text id="soa.para6" />
              </p>
              {this.props.customerId===ILS_CONSTS.ID &&
              <>
                <div class="form-group row mt-3">
                <p className="col-md-12"><strong><Text id="app.middileInitialheader1"/></strong></p>
              <div class="col-md-3">
                <label for="beneficiaryInitial" class="control-label">
                  <Text id="app.beneficiaryInitial"/>*
                </label>
                <input
                  type="text"
                  id="beneficiaryInitial"
                  name="beneficiaryInitial"
                  value={this.state.Soa?.beneficiaryInitial}
                  maxLength="255"
                  onChange={this.handleChange}
                  class={
                    this.state.Soa?.beneficiaryInitial === ""
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <p className="col-md-9 mt-5"><Text id="app.middileInitialheader2"/></p>
              </div>
              </>
              }
              <p class="mt-3">
                <Text id="soa.para7" />
                <strong>
                  <Text id="soa.para8" />
                </strong>
                <Text id="soa.para9" />
              </p>
            </div>
            {this?.props.planCardData.length > 0
              ? customCardArray.map((plans, index) => (
                  <label class="soaplans" key={index}>
                    <input
                      type="checkbox"
                      //class="customCheckbox"
                      class={
                        plans?.disable
                        ?"checkbox-input"
                        :this.state?.productSelected >= 1
                          ? "checkbox-input"
                          : "checkbox-input-error"
                      }
                      id={plans.productId}
                      name="productIds"
                      value={plans.productId}
                      checked={
                        this.state?.Soa?.productIds?.includes(plans.productId)
                          ? true
                          : false
                      }
                      onChange={this.handleMutipleCheckbox}
                      disabled={plans?.disable??false}
                    />{" "}
                    <strong>{this.props.lang==="en"?plans.planName:plans?.planNameES}</strong>
                  </label>
                ))
              : null}
            <div class="mt-3">
              <h5>
                <strong><Text id="app.requiredAll"/></strong>
              </h5>
              <p>
                *<Text id="app.agentContract"/>
              </p>
            </div>
            <div class="form-group row mt-3">
              <div class="col-md-6">
                <label for="agentName" class="control-label">
                  <Text id="app.writtingId"/>*
                </label>
                <input
                  type="text"
                  id="agentName"
                  name="agentName"
                  value={this.state.Soa.agentName}
                  maxLength="40"
                  disabled={true}
                  onChange={this.handleChange}
                  class={
                    this.state.Soa.agentName === ""
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-6">
                <label for="agentPhone" class="control-label">
                  <Text id="app.agentPh"/>*
                </label>
                <input
                  type="text"
                  id="agentPhone"
                  name="agentPhone"
                  maxLength={this.props.customerId===ILS_CONSTS.ID?"12":"14"}
                  value={this.state.Soa.agentPhone}
                  onChange={this.handleChange}
                  class={
                    this.state.Soa?.agentPhone.includes("-") && //this is for Ils
                    this.state.Soa?.agentPhone.length===12
                    ?"form-control"
                    :this.state.Soa?.agentPhone === "" ||
                    this.state.Soa?.agentPhone?.indexOf("(") === -1 ||
                    this.state.Soa?.agentPhone?.indexOf("(") === -1
                      ? "error-input"
                      : "form-control"
                  }
                  placeholder="(   )   -"
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-6">
                <label for="beneficiaryName" class="control-label">
                  <Text id="app.beneficiaryNm"/>*
                </label>
                <input
                  type="text"
                  id="beneficiaryName"
                  name="beneficiaryName"
                  value={this.state.Soa.beneficiaryName}
                  maxLength="40"
                  onChange={(event) => {
                    if (
                      event.target.value !== "" &&
                      !DataValidation.test(event.target.value)
                    ) {
                      return;
                    }
                    this.handleChange(event);
                  }}
                  class={
                    this.state.Soa.beneficiaryName === ""
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-6">
                <label for="beneficiaryPhone" class="control-label">
                  <Text id="app.benePh"/>*
                </label>
                <input
                  type="text"
                  maxLength="14"
                  id="beneficiaryPhone"
                  name="beneficiaryPhone"
                  value={this.state.Soa.beneficiaryPhone}
                  onChange={this.handleChange}
                  class={
                    this.state?.Soa?.beneficiaryPhone === "" ||
                    this.state?.Soa?.beneficiaryPhone?.indexOf("(") === -1 ||
                    this.state?.Soa?.beneficiaryPhone?.indexOf("(") === -1
                      ? "error-input"
                      : "form-control"
                  }
                  placeholder="(   )   -"
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-6">
                <label for="beneficiaryAddress" class="control-label">
                  <Text id="app.beneAddr"/>*
                </label>
                <input
                  type="text"
                  id="beneficiaryAddress"
                  name="beneficiaryAddress"
                  value={this.state.Soa.beneficiaryAddress}
                  maxLength="40"
                  onChange={this.handleChange}
                  class={
                    this.state.Soa.beneficiaryAddress === ""
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              {this.props.customerId === ILS_CONSTS.ID && (
                <div class="col-md-6">
                  <label for="beneficiaryAddress" class="control-label">
                    <Text id="app.medicaidId"/>
                  </label>
                  <input
                    type="text"
                    id="medicaidId"
                    name="medicaidId"
                    value={this.state.Soa?.medicaidId ?? ""}
                    maxLength="10"
                    onChange={(event) => this.handleChange(event)}
                    class={"form-control"}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
              )}
              {this.props.customerId === NEBRASKA_CONSTS.ID && (
                <div class="col-md-6">
                  <label for="beneBirthDate" class="control-label">
                    <Text id="app.beneDob"/>
                  </label>
                  <input
                    type="text"
                    id="beneBirthDate"
                    name="beneBirthDate"
                    value={this.state.Soa?.beneBirthDate}
                    maxLength="10"
                    onChange={this.handleDate}
                    onClick={(e) => this.handleDates("beneBirthDate")}
                    placeholder="MM/DD/YYYY"
                    className={
                      // this.state.Soa?.beneBirthDate === "" ||
                      // !moment(
                      //   this.state.Soa?.beneBirthDate,
                      //   "MM/DD/YYYY",
                      //   true
                      // ).isValid()
                      //   ? "error-input scrollfix"
                      "form-control scrollfix"
                    }
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
              )}
            </div>
            <div class="form-group row mt-3 mb-3">
              <label
                for="agentName"
                class={
                  (this.state.Soa.initialMethodOfContact == "" &&
                    this.state.Soa.initialMethodOfContact != "Other") ||
                  (this.state.Soa.initialMethodOfContact === "Other" &&
                    this.state.Soa.salesChannelOth === "")
                    ? "control-label soa-contact initial-method-ml-15px"
                    : "control-label initial-method-ml-15px"
                }
              >
                <Text id="app.initialContact"/>*
              </label>
              <FormControl component="fieldset" className="col-md-12">
                <RadioGroup
                  aria-label="Plans"
                  name="initialMethodOfContact"
                  id="initialMethodOfContact"
                  value={this.state.Soa.initialMethodOfContact}
                  onChange={this.handleChange}
                  className="radioRow"
                >
                  {this.state.IMC.map((data1) => (
                    <div class="col-md-6">
                      <FormControlLabel
                        value={data1.value}
                        control={<Radio color="primary" />}
                        label={data1.label}
                      />

                      {data1.value === "Other" &&
                        this.state.Soa.initialMethodOfContact === "Other" && (
                          <div class="display-inline-block">
                            <input
                              type="text"
                              id="salesChannelOth"
                              name="salesChannelOth"
                              value={this.state.Soa.salesChannelOth}
                              onChange={this.handleChange}
                              class={
                                this.state.Soa.salesChannelOth === ""
                                  ? "error-input"
                                  : "form-control"
                              }
                              maxLength="30"
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                            />
                          </div>
                        )}
                    </div>
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
            {this.props.customerId === NEBRASKA_CONSTS.ID && (
              <div className="form-group row mt-3">
                <div class="col-md-6">
                  <label for="dateApntmntCmpltd" class="control-label">
                    <Text id="app.dateAppointment"/>*
                  </label>
                  <input
                    value={this.state.Soa.dateApntmntCmpltd}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    maxLength="10"
                    onChange={this.handleDate}
                    onClick={(e) => this.handleDates("dateApntmntCmpltd")}
                    name="dateApntmntCmpltd"
                    id="dateApntmntCmpltd"
                    placeholder="MM/DD/YYYY"
                    class={
                      this.state.Soa.dateApntmntCmpltd === "" ||
                      !moment(
                        this.state.Soa.dateApntmntCmpltd,
                        "MM/DD/YYYY",
                        true
                      ).isValid()
                        ? "error-input scrollfix"
                        : "form-control scrollfix"
                    }
                  />
                </div>
              </div>
            )}
            <div class="form-group row mt-3">
              <div class="col-md-6">
                <label for="agentSignutre" class="control-label">
                  <Text id="app.agentSignature"/>*
                </label>
                <input
                  type="text"
                  id="agentSignutre"
                  name="agentSignutre"
                  value={this.state.Soa.agentSignutre}
                  maxLength="40"
                  onChange={(event) => {
                    if (
                      event.target.value !== "" &&
                      !DataValidation.test(event.target.value)
                    ) {
                      return;
                    }
                    this.handleChange(event);
                  }}
                  class={
                    this.state.Soa.agentSignutre === ""
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              {this.props.customerId !== NEBRASKA_CONSTS.ID && (
                <div class="col-md-6">
                  <label for="dateApntmntCmpltd" class="control-label">
                    <Text id="app.dateAppointment"/>*
                  </label>
                  <input
                    value={this.state.Soa.dateApntmntCmpltd}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    maxLength="10"
                    onChange={this.handleDate}
                    onClick={(e) => this.handleDates("dateApntmntCmpltd")}
                    name="dateApntmntCmpltd"
                    id="dateApntmntCmpltd"
                    placeholder="MM/DD/YYYY"
                    class={
                      this.state.Soa.dateApntmntCmpltd === "" ||
                      !moment(
                        this.state.Soa.dateApntmntCmpltd,
                        "MM/DD/YYYY",
                        true
                      ).isValid()
                        ? "error-input scrollfix"
                        : "form-control scrollfix"
                    }
                  />
                </div>
              )}
              {this.props.customerId === NEBRASKA_CONSTS.ID && (
                <div class="col-md-6">
                  <label for="agentSignDate" class="control-label">
                    <Text id="app.date"/>*
                  </label>
                  <input
                    type="text"
                    value={this.state.Soa?.agentSignDate}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    maxLength="10"
                    onChange={this.handleDate}
                    onClick={(e) => this.handleDates("agentSignDate")}
                    name="agentSignDate"
                    id="agentSignDate"
                    placeholder="MM/DD/YYYY"
                    class={
                      this.state.Soa?.agentSignDate === "" ||
                      !moment(
                        this.state.Soa?.agentSignDate,
                        "MM/DD/YYYY",
                        true
                      ).isValid()
                        ? "error-input scrollfix"
                        : "form-control scrollfix"
                    }
                  />
                </div>
              )}
              <div class="col-md-6"></div>
            </div>
            <div class="mt-3 mb-3">
              <h5>
                <strong><Text id="app.authRep"/>:</strong>
              </h5>
            </div>
            <div class="form-group row mt-3">
              <div class="col-md-6">
                <label for="repSignature" class="control-label">
                  <Text id="app.signature"/>*
                </label>
                <input
                  type="text"
                  id="repSignature"
                  name="repSignature"
                  value={this.state.Soa.repSignature}
                  maxLength="40"
                  onChange={(event) => {
                    if (
                      event.target.value !== "" &&
                      !DataValidation.test(event.target.value)
                    ) {
                      return;
                    }
                    this.handleChange(event);
                  }}
                  class={
                    this.state.Soa.repSignature === ""
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-6">
                <label for="repDate" class="control-label">
                  <Text id="app.date"/>*
                </label>
                <input
                  class={
                    this.state.Soa.repDate === "" ||
                    !moment(
                      this.state.Soa.repDate,
                      "MM/DD/YYYY",
                      true
                    ).isValid()
                      ? "error-input scrollfix"
                      : "form-control scrollfix"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  value={this.state.Soa.repDate}
                  maxLength="10"
                  onChange={this.handleDate}
                  onClick={(e) => this.handleDates("repDate")}
                  name="repDate"
                  id="repDate"
                  placeholder="MM/DD/YYYY"
                />
              </div>
            </div>
            <div class="mt-3 mb-3">
              <h5>
                <strong>
                  <Text id="app.soaPara"/>
                  <input
                    type="checkbox"
                    class={
                      // this.state?.productSelected >= 1
                      //   ?
                      "checkbox-input ml-1"
                      // : "checkbox-input-error"
                    }
                    id="isAuthRep"
                    name="isAuthRep"
                    checked={this.state.Soa.isAuthRep === "YES" ? true : false}
                    onChange={(event) => {
                      let name = event.target ? event.target.name : event.name;
                      let value = event.target
                        ? event.target.checked
                          ? "YES"
                          : "NO"
                        : event.checked
                        ? "YES"
                        : "NO";
                      this.setState({
                        Soa: {
                          ...this.state.Soa,
                          [name]: value,
                        },
                      });
                      this.props.saveAgentDetails(name, value);
                    }}
                    value={this.state.Soa.isAuthRep}
                  />
                </strong>
              </h5>
            </div>
            <div class="form-group row mt-3">
              <div class="col-md-6">
                <label for="repName" class="control-label">
                  <Text id="app.repNm"/>
                  {this.state.Soa.isAuthRep === "YES" && "*"}
                </label>
                <input
                  type="text"
                  id="repName"
                  name="repName"
                  value={this.state.Soa.repName}
                  maxLength="40"
                  onChange={(event) => {
                    if (
                      event.target.value !== "" &&
                      !DataValidation.test(event.target.value)
                    ) {
                      return;
                    }
                    this.handleChange(event);
                  }}
                  class={
                    this.state.Soa.repName === "" &&
                    this.state.Soa.isAuthRep === "YES"
                      ? "error-input"
                      : "form-control"
                  }
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
              </div>
              <div class="col-md-6">
                <label for="relationship" class="control-label">
                  <Text id="app.relntoBene"/>
                  {this.state.Soa.isAuthRep === "YES" && "*"}
                </label>
                <select
                  id="repRelationShip"
                  name="repRelationShip"
                  class={
                    this.state.Soa.repRelationShip === "" &&
                    this.state.Soa.isAuthRep === "YES"
                      ? "error-input"
                      : "form-control"
                  }
                  value={this.state.Soa.repRelationShip}
                  onChange={this.handleChange}
                >
                  {this.props.authorizedrelations.map((item, i) => {
                    return (
                      <option class="select-option" value={item.value} key={i}>
                        {item.label}
                      </option>
                    );
                  })}
                  {/* <option class="select-option" value="SELF">
                    SELF
                  </option> */}
                </select>
              </div>
            </div>
            <div class="mt-3">
              <p>{FieldLabel("soaFooter", this.props.customerId)}</p>
            </div>
            {this.props.preEnrollInfo?.appStatus != "READY" &&
              this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                <button
                  class="btn btn-saveNext save-next-color"
                  id="next0"
                  onClick={this.saveAndNext}
                  // disabled={this.props.preEnrollInfo?.appStatus==="READY" || this.props.preEnrollInfo?.appStatus==="SUBMITTED"}

                  //style={{ backgroundColor: "#603167" }}
                  disabled={
                    this.props?.Submitted ||
                    this.props.preEnrollInfo?.appStatus === "READY" ||
                    this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                  }
                >
                  <Text id="app.Save_Next" />
                </button>
              )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { selectedPlanName, county, stateCd } = state.webApp;
  return {
    cardDetails: state.webApp.planCardData,
    planCardData: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    guestLoggedIn: state.login.guestLogin,
    stateName: state.webApp.state,
    countyName: state.webApp.county,
    email: state.login.emailAddress,
    planId: state.webApp.emailPlanId,
    agentLogin: state.login.agentLoggedIn,
    ZipCodes: state.webApp.zipCodes,
    selectedPlanName,
    county,
    stateCd,
    prospectEnroll: state.webApp.prospectEnroll,
    SOAData: state.campaignProspect.SOAData,
    preEnrollInfo: state.webApp.preEnrollInfo,
    Submitted: state.webApp.Submitted,
    soa: state.webApp.soa,
    pendingApplFlag: state.webApp.pendingApplFlag,
    agentFullName: state.login.agentFullName,
    agentId: state.login.agentId,
    agentPhone: state.login.agentPhone,
    customerId: state.login.customerId,
    lang: state.webApp.language,
  };
};
const mapDispatchToProps = {
  saveAgentDetails,
  saveAgentproductIds,
  setStateParams,
};
export default connect(mapStateToProps, mapDispatchToProps)(Soa);
